import { Component,OnInit,Input,EventEmitter, Output} from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { AppService } from 'src/app/services/app.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { StorageService } from 'src/app/services/storage.service';
import { MatDialog } from '@angular/material/dialog';
import { PagamentoFileReprovadoModal } from 'src/app/components/pagamento/pagamento-file-reprovado-modal/pagamento-file-reprovado-modal.component';
import { PagamentoReprovadoModal } from 'src/app/components/pagamento/pagamento-reprovado-modal/pagamento-reprovado-modal.component';
import { PagamentoAprovadoModal } from 'src/app/components/pagamento/pagamento-aprovado-modal/pagamento-aprovado-modal.component';

@Component({
  selector: 'modulo-pagamento',
  templateUrl: './pagamento.component.html',
  styleUrls: ['./pagamento.component.scss'] 
})
export class PagamentoComponent implements OnInit {

  @Input("data") data:any              = {};
  @Input("carrinho") carrinho:any      = {};  
  @Input("template") template          = {};
  @Input("classCustom") classCustom    = {};
  @Input("onEmit") onEmit              = new EventEmitter();   
  @Output("endLoader") endLoader       = new EventEmitter();   
  @Output("endPagamento") endPagamento = new EventEmitter();  

  public dataItem:any                  = {}; 
  public _params:any                   = {};
  public loader                        = false;
  public usuario                       = null;

  constructor(
    private api: ApiService,
    private app: AppService,
    private usuarioService: UsuarioService,
    private storage: StorageService,
    private dialog: MatDialog
  ){ }

  /**
   * 
   * Inicializa o dataItem
   * 
   */
  initDataItem(){

    this.dataItem = {
      email: "",
      nome: "",
      data_nascimento: "",
      telefone: "",
      cpf: "",
      rg: "",
      cartao: { 
        numero_cartao: "",
        data_validade: "",
        codigo_seguranca: "",
        nome_portador: "",
        parcelas: "" 
      }, 
      passageiros: [], 
      pagamento_id: this.data._params.id, 
      solicitar_passageiros: false,
      apelido: this.data._params.intermediador_apelido  
    } 

  }
  /**
   * 
   * Finaliza o pagamento  
   * 
   * 
   */
  finalizar(){

    try{  

      this.loader = true;  

      this.api.pagamento().finalizar(this.dataItem).subscribe(response => {

        this.loader = false;
        this.endLoader.emit(null);  
        
        switch(response.status){
          case 1:

            let dataFile = response.data.file;
            let dataPay  = response.data.pay;

            if(dataFile.status == 500){

              this.dialog.open(PagamentoFileReprovadoModal,{
                width: "700px",
                height: "auto",
                data: {
                  detalhes: dataFile.data 
                }
              });

            }else if(dataPay.status == 500){

              this.dialog.open(PagamentoReprovadoModal,{
                width: "500px",
                height: "auto", 
                data: {
                  file: dataFile.data,
                  detalhes: dataPay.data
                }
              }); 

            }else{

              /*this.dialog.open(PagamentoAprovadoModal,{
                width: "450px",
                height: "auto"
              });*/
              this.endPagamento.emit({
                solicitar_passageiros: this.dataItem.solicitar_passageiros,
                dataFile: dataFile,
                dataPay: dataPay,
                email: this.dataItem.email,
                nome: this.dataItem.nome,
                telefone: this.dataItem.telefone,
                data_nascimento: this.dataItem.data_nascimento,
                cpf: this.dataItem.cpf,
                rg: this.dataItem.rg
              }); 

            }


          break;
          case 422:

            let errors = this.app.formarErrorsValidation([response.data.dados]); 
            
            if(response.data.passageiros.length > 0){
 
              errors += this.app.formartErrorsValidationPassageiros(response.data.passageiros);  
   
            }  

            this.app.info(errors,"danger");  

          break;
          default: 
            this.app.info(response.data,"danger");
          break;
        }

      },(response) => {

        this.endLoader.emit(null);
        this.loader = false;
        let errors  = this.app.formatError(response); 

        this.app.info(errors.message,"danger"); 

      });

    }catch(e){

      this.endLoader.emit(null);
      this.loader = false;

    }

  }
  /**
   * 
   * Open modal reserva
   * 
   */
  _openModalReserva(){

    this.dialog.open(PagamentoFileReprovadoModal,{
      width: "500px",
      height: "auto", 
      data: {
        detalhes: "Teste detalhes"
      }
    }); 

  }
  /**
   * 
   * Open modal pagamento
   * 
   */ 
  _openModalPagamento(){

    this.dialog.open(PagamentoReprovadoModal,{
      width: "500px",
      height: "auto", 
      data: {
        file: 30029,
        detalhes: "Teste detalhes"
      }
    }); 

  }
  /**
   * 
   * Open modal pagamento
   * 
   */ 
  _openAprovado(){

    this.dialog.open(PagamentoAprovadoModal,{
      width: "450px",
      height: "auto"
    }); 

  }
  /**
   * 
   * On Events
   * 
   */
  onEvents(){

    this.onEmit.subscribe((response) => {

      this.finalizar(); 

    });  

    this.usuarioService.emitUsuarioLogin.subscribe((usuario) => {

      if(usuario != null){
        
        this.dataItem.nome    = usuario.nome;
        this.dataItem.email   = usuario.email;
        
        if(typeof(usuario.cpf) != "undefined"){
          this.dataItem.cpf = usuario.cpf;
        }
        if(typeof(usuario.rg) != "undefined"){
          this.dataItem.rg = usuario.rg; 
        }
        if(typeof(usuario.telefone) != "undefined"){
          this.dataItem.telefone = usuario.telefone; 
        }
        if(typeof(usuario.data_nascimento) != "undefined"){
          this.dataItem.data_nascimento = usuario.data_nascimento; 
        }

      }

    });

  }
  /**
   * 
   * 
   * 
   */
  setUsuario(){
  
    this.usuario = this.carrinho.usuario ? this.carrinho.usuario : this.storage.getUsuario(); 

    if(this.usuario != null){
      
      this.dataItem.nome    = this.usuario.nome;
      this.dataItem.email   = this.usuario.email;

      if(this.carrinho.cart_dados.cpf !== null && this.carrinho.cart_dados.cpf !== ""){
        this.dataItem.cpf =  this.carrinho.cart_dados.cpf; 
      }else if(typeof(this.usuario.cpf) != "undefined"){
        this.dataItem.cpf = this.usuario.cpf;
      }
      if(this.carrinho.cart_dados.rg !== null && this.carrinho.cart_dados.rg !== ""){
        this.dataItem.rg = this.carrinho.cart_dados.rg;
      }else if(typeof(this.usuario.rg) != "undefined"){
        this.dataItem.rg =  this.usuario.rg; 
      }
      if(this.carrinho.cart_dados.telefone !== null && this.carrinho.cart_dados.telefone !== ""){
        this.dataItem.telefone = this.carrinho.cart_dados.telefone;
      }else if(typeof(this.usuario.telefone) != "undefined"){
        this.dataItem.telefone = this.usuario.telefone; 
      }
      if(this.carrinho.cart_dados.data_nascimento !== null && this.carrinho.cart_dados.data_nascimento !== ""){
        this.dataItem.data_nascimento = this.carrinho.cart_dados.data_nascimento;
      }else if(typeof(this.usuario.data_nascimento) != "undefined"){ 
        this.dataItem.data_nascimento = this.usuario.data_nascimento; 
      } 

    }

  }
  /**
   * 
   * Solicitar Passageiros
   * 
   */
  _setSolicitarPassageiros(value){

    this.dataItem.solicitar_passageiros = value; 

  }
  /**
   * 
   * Incializa as Funções
   * 
   */
  ngOnInit():void{
    this.initDataItem(); 
    this.onEvents();
    this.setUsuario();
  }

}
